"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _atomize = _interopRequireDefault(require("@quarkly/atomize"));
var _reactRouterDom = require("react-router-dom");
var _router = require("@reach/router");
var _widgets = require("@quarkly/widgets");
var _components = require("@quarkly/components");
var _props = require("./props");
var _utils = require("../utils");
var _utils2 = require("./utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Ul = _atomize["default"].ul();
var Li = _atomize["default"].li();
var Item = function Item(_ref) {
  var _item$children;
  var _ref$exact = _ref.exact,
    exact = _ref$exact === void 0 ? false : _ref$exact,
    override = _ref.override,
    item = _ref.item;
  var hasSub = !!(item !== null && item !== void 0 && (_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length);
  var common = {
    exact: exact,
    override: override,
    item: item
  };
  var _ref2 = (0, _utils.getAPI)() || {},
    projectType = _ref2.projectType;
  var href = item.absoluteUrl;
  var match = null;
  if (projectType === 'gatsby') {
    match = (0, _router.useMatch)(href) || null; // eslint-disable-line
  } else {
    match = (0, _reactRouterDom.useRouteMatch)({
      path: href,
      exact: exact
    }) || null; // eslint-disable-line
  }
  var name = item.name,
    pageUrl = item.pageUrl;
  var linkProps = override('link', match && 'link-active', "link-".concat(pageUrl), {
    defaultKey: "link-".concat(pageUrl)
  });
  return /*#__PURE__*/_react["default"].createElement(Li, override('item', match && 'item-active', "item-".concat(pageUrl), {
    defaultKey: "item-".concat(pageUrl)
  }), /*#__PURE__*/_react["default"].createElement(_widgets.Link, _extends({
    href: href
  }, linkProps), linkProps.children || name), hasSub && /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
    tree: item
  }, common, override('sub', "sub-".concat(pageUrl)))));
};
var Wrapper = function Wrapper(_ref3) {
  var _tree$children;
  var override = _ref3.override,
    exact = _ref3.exact,
    tree = _ref3.tree,
    rest = _objectWithoutProperties(_ref3, ["override", "exact", "tree"]);
  var common = {
    override: override,
    exact: exact,
    tree: tree
  };
  var list = (_tree$children = tree === null || tree === void 0 ? void 0 : tree.children) !== null && _tree$children !== void 0 ? _tree$children : [];
  return /*#__PURE__*/_react["default"].createElement(Ul, rest, list.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(Item, _extends({
      key: item.id,
      item: item
    }, common));
  }));
};
var Menu = function Menu(_ref4) {
  var _ref4$rootId = _ref4.rootId,
    rootUrl = _ref4$rootId === void 0 ? '' : _ref4$rootId,
    depth = _ref4.depth,
    filterMode = _ref4.filterMode,
    origFilterPages = _ref4.filterPages,
    exact = _ref4['exact-active-match'],
    props = _objectWithoutProperties(_ref4, ["rootId", "depth", "filterMode", "filterPages", "exact-active-match"]);
  var _useOverrides = (0, _components.useOverrides)(props, _props.overrides, _props.defaultProps),
    override = _useOverrides.override,
    rest = _useOverrides.rest;
  var pages = (0, _utils.getAPI)().pages || {};
  var filterPages = (origFilterPages === null || origFilterPages === void 0 ? void 0 : origFilterPages.length) > 0 ? origFilterPages.split(',') : [];
  var tree = _utils2.PageTreeNode.fromPages(pages).findSubtreeByUrl(rootUrl).filterByPages(filterMode, filterPages).truncate(depth);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
    tree: tree,
    depth: depth,
    exact: exact,
    override: override,
    padding: "6px",
    margin: "0px",
    "list-style": "none"
  }, rest));
};
Object.assign(Menu, {
  title: 'Menu',
  description: {
    en: 'Use this component to add a simple menu to your website',
    ru: 'Простое меню для вашего сайта'
  },
  defaultProps: _props.defaultProps,
  overrides: _props.overrides,
  propInfo: _props.propInfo
});
var _default = Menu;
exports["default"] = _default;